module.exports = __webpack_public_path__ + "static/media/medicine.709ab726.png";